import "./_style.less";
import React, { useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { AssessmentIcon, CounselingIcon } from "../../icons";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import clsx from "clsx";

const FloatingBookNow: React.FC = () => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="floating-book-now">
      <div
        className={clsx("floating-overlay ", {
          show: open,
        })}
        onClick={() => setOpen(false)}
      />

      <div className="floating-container">
        <div
          className={clsx("floating-menu", {
            open: open,
          })}
        >
          <Link to="/booking-counseling">
            <div className="floating-item">
              <div>
                <div className="floating-item-icon">
                  <CounselingIcon />
                </div>
              </div>
              <span className="floating-item-text">
                {t("common.text.counselingAndPsychotherapy")}
              </span>
            </div>
          </Link>
          <Link to="/booking-assessment">
            <div className="floating-item">
              <div>
                <div className="floating-item-icon">
                  <AssessmentIcon />
                </div>
              </div>

              <span className="floating-item-text">
                {t("common.text.assessmentAndPrograms")}
              </span>
            </div>
          </Link>
        </div>

        <div className="floating-btn" onClick={() => setOpen(!open)}>
          {open ? <CloseOutlined /> : t("common.text.bookNow")}
        </div>
      </div>
    </div>
  );
};

export default FloatingBookNow;
